"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tab = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Tab = ({
  contents,
  activeTabClassName,
  titleClassName,
  bodyClassName,
  activeTab,
  titleStyle,
  bodyStyle,
  ...rest
}) => {
  const [key, setKey] = (0, _react.useState)();
  const [contentBody, setContentBody] = (0, _react.useState)();

  const onTab = (title, body, id) => {
    id ? setKey(id) : setKey(title);
    setContentBody(body);
  };

  (0, _react.useEffect)(() => {
    if (activeTab) {
      setActiveTab(activeTab);
    } else if (contents.length > 0) {
      var _contents$, _contents$2, _contents$3, _contents$4;

      setKey(contents !== null && contents !== void 0 && (_contents$ = contents[0]) !== null && _contents$ !== void 0 && _contents$.id ? contents === null || contents === void 0 ? void 0 : (_contents$2 = contents[0]) === null || _contents$2 === void 0 ? void 0 : _contents$2.id : contents === null || contents === void 0 ? void 0 : (_contents$3 = contents[0]) === null || _contents$3 === void 0 ? void 0 : _contents$3.title);
      setContentBody(contents === null || contents === void 0 ? void 0 : (_contents$4 = contents[0]) === null || _contents$4 === void 0 ? void 0 : _contents$4["children"]);
    }
  }, [activeTab]);

  const setActiveTab = id => {
    contents.forEach(val => {
      if ((val === null || val === void 0 ? void 0 : val.id) === id) {
        setKey(val === null || val === void 0 ? void 0 : val.id);
        setContentBody(val === null || val === void 0 ? void 0 : val.children);
      }
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sp-pt--48 sp-w-100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sp-tabs"
  }, contents.map((val, i) => {
    const tabKey = val !== null && val !== void 0 && val.id ? val.id === key : val.title === key;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      style: titleStyle,
      className: `${titleClassName} ${tabKey && `active  ${activeTabClassName}`} sp-tabs--item`,
      onClick: () => onTab(val.title, val.children, val === null || val === void 0 ? void 0 : val.id)
    }, val.title);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: bodyClassName,
    style: bodyStyle
  }, contentBody));
};

exports.Tab = Tab;
Tab.defaultProps = {
  contents: [],
  titleClassName: "",
  bodyClassName: "",
  activeTabClassName: "",
  defaultActive: {},
  titleStyle: {},
  bodyStyle: {},
  activeTab: ""
};
Tab.propTypes = {
  contents: _propTypes.default.array,
  titleClassName: _propTypes.default.string,
  bodyClassName: _propTypes.default.string,
  activeTabClassName: _propTypes.default.string,
  defaultActive: _propTypes.default.object,
  titleStyle: _propTypes.default.object,
  bodyStyle: _propTypes.default.object,
  activeTab: _propTypes.default.any
};
var _default = Tab;
exports.default = _default;